// Token Manager for secure localStorage handling
export const tokenManager = {
  // Store encrypted token
  storeToken: (token, tokenType, expiresIn) => {
    try {
      // Ensure expiresIn is a number
      const expiresInNum = typeof expiresIn === 'number' ? expiresIn : parseInt(expiresIn) || 43200;
      
      const encryptedToken = btoa(token);
      const encryptedTokenType = btoa(tokenType);
      const encryptedExpiresIn = btoa(expiresInNum.toString());
      const encryptedExpiryTime = btoa((Date.now() + (expiresInNum * 1000)).toString());
      
      localStorage.setItem('_auth', encryptedToken);
      localStorage.setItem('_type', encryptedTokenType);
      localStorage.setItem('_exp', encryptedExpiresIn);
      localStorage.setItem('_expTime', encryptedExpiryTime);
      
      return true;
    } catch (error) {
      console.error('Error storing token:', error);
      return false;
    }
  },

  // Get decrypted token
  getToken: () => {
    try {
      const encryptedToken = localStorage.getItem('_auth');
      if (!encryptedToken) return null;
      
      return atob(encryptedToken);
    } catch (error) {
      console.error('Error getting token:', error);
      return null;
    }
  },

  // Get token type
  getTokenType: () => {
    try {
      const encryptedType = localStorage.getItem('_type');
      if (!encryptedType) return null;
      
      return atob(encryptedType);
    } catch (error) {
      console.error('Error getting token type:', error);
      return null;
    }
  },

  // Check if token is expired
  isTokenExpired: () => {
    try {
      const encryptedExpiryTime = localStorage.getItem('_expTime');
      if (!encryptedExpiryTime) return true;
      
      const expiryTime = parseInt(atob(encryptedExpiryTime));
      return Date.now() > expiryTime;
    } catch (error) {
      console.error('Error checking token expiry:', error);
      return true;
    }
  },

  // Get authorization header
  getAuthHeader: () => {
    const token = tokenManager.getToken();
    const tokenType = tokenManager.getTokenType();
    
    if (!token || tokenManager.isTokenExpired()) {
      return null;
    }
    
    return `${tokenType} ${token}`;
  },

  // Clear all token data
  clearToken: () => {
    localStorage.removeItem('_auth');
    localStorage.removeItem('_type');
    localStorage.removeItem('_exp');
    localStorage.removeItem('_expTime');
  },

  // Check if user is authenticated
  isAuthenticated: () => {
    const token = tokenManager.getToken();
    return token && !tokenManager.isTokenExpired();
  }
}; 